import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { PageTransition } from '../animations/PageTransition';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import { Socials } from '../components/Socials';

import { Helmet } from 'react-helmet';

export const Found404 = ({ transition }) => {
	return (
		<motion.main className="error404" transition={transition} exit={{ opacity: 0 }}>
			<PageTransition />
			<Helmet>
				<title>Page Not Found (404) – Spring Studio</title>
				<meta
					name="description"
					content="The page you’re looking for could not be found. Spring Studio is a creative studio rental in Stockholm for photography, film, and productions."
				/>
				<meta property="og:title" content="Page Not Found (404) – Spring Studio" />
				<meta property="og:description" content="The page you’re looking for could not be found. Visit Spring Studio to explore our creative studio rental in Stockholm." />
				<link rel="canonical" href="https://springstudio.se/404" />
				<meta name="robots" content="noindex, follow" />
			</Helmet>
			<section className="section error-404 not-found">
				<div className="row">
					<div className="col col-6 offset-l-3 offset-r-3">
						<div className="module-text heading">
							<h1 className="d1" data-text="404">
								404
							</h1>
							<p className="md">The page you requested could not be found. Click the button below or use the navigation to get back on track.</p>
						</div>
						<div className="module-button">
							<Link to="/" className="btn btn-primary">
								<BsArrowLeft />
								Back home
							</Link>
						</div>
					</div>
				</div>
			</section>
			<section className="section section-contact">
				<div className="row theme-dark">
					<div className="col col-6">
						<div className="module-text">
							<h2 className="fade d1" data-text={'Ready to book the studio?'}>
								Ready to book the studio?
							</h2>
							<p className="fade sm">Spring Studio is ready for your next creative project. Reach out today to book your session and make the most of our versatile space.</p>
						</div>
						<div className="studio-single-socials-container">
							<Socials />
						</div>
					</div>

					<div className="col col-6">
						<div className="button-wrapper">
							<Link to="/contact" className="btn btn-primary">
								Contact
							</Link>
							<Link to="/studio" className="btn btn-secondary">
								View the studio <BsArrowRight />
							</Link>
						</div>
					</div>
				</div>
			</section>
		</motion.main>
	);
};
